export default function isImage(string) {
  const validImages = ["jpeg", "jpg", "png", "gif"];
  return validImages.includes(string.split('.').reverse()[0]);
}